import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast";

interface BookerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

interface BookerProps {
  eventSlug: string;
  username: string;
  view: "month_view" | "column_view" | "week_view";
  customClassNames?: {
    bookerContainer?: string;
  };
  onCreateBookingSuccess?: () => void;
}

export const BookerModal = ({ open, onOpenChange }: BookerModalProps) => {
  const { toast } = useToast();

  const handleBookingSuccess = () => {
    toast({
      title: "Consultation Booked Successfully!",
      description: "We'll send you a confirmation email shortly. Looking forward to speaking with you!",
    });
    
    // Auto-close modal after successful booking
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            Schedule Your PEO Expert Consultation
          </DialogTitle>
        </DialogHeader>
        
        <div className="mt-6">
          <iframe
            src="https://cal.com/thepeoapp/meet?embed=true"
            width="100%"
            height="600"
            style={{
              border: "1px solid hsl(var(--border))",
              borderRadius: "8px"
            }}
            title="Schedule PEO Expert Consultation"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};